"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse200ToJSON = exports.InlineResponse200FromJSONTyped = exports.InlineResponse200FromJSON = void 0;
var runtime_1 = require("../runtime");
function InlineResponse200FromJSON(json) {
    return InlineResponse200FromJSONTyped(json, false);
}
exports.InlineResponse200FromJSON = InlineResponse200FromJSON;
function InlineResponse200FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'success': !(0, runtime_1.exists)(json, 'success') ? undefined : json['success'],
        'message': !(0, runtime_1.exists)(json, 'message') ? undefined : json['message'],
        'steamData': !(0, runtime_1.exists)(json, 'steamData') ? undefined : json['steamData'],
        'lastRefreshed': !(0, runtime_1.exists)(json, 'lastRefreshed') ? undefined : json['lastRefreshed'],
    };
}
exports.InlineResponse200FromJSONTyped = InlineResponse200FromJSONTyped;
function InlineResponse200ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'success': value.success,
        'message': value.message,
        'steamData': value.steamData,
        'lastRefreshed': value.lastRefreshed,
    };
}
exports.InlineResponse200ToJSON = InlineResponse200ToJSON;
